import { createSignal, createEffect, on, onCleanup } from 'solid-js';

export * from './loaders';
export * from './datafunc';
export * from './gridfunc';
export * from './tooltip';
export * from './compare';
// matcher-cache is an internal implementation detail of compare/event-match.
// Its test/inspection helpers (clearMatcherCache, matcherCacheSize) and
// internals (getMatcher, isGlobPattern) are intentionally NOT part of the
// public utils API; tests import them directly from './matcher-cache'.
export * from './event-match';
export * from './debug';
export * from './time';

export function useDebounceValue(signal, delay) {
  const [debouncedSignal, setDebouncedSignal] = createSignal(signal());
  let timerHandle;
  createEffect(
    on(signal, (s) => {
      timerHandle = setTimeout(() => {
        setDebouncedSignal(s);
      }, delay);
      onCleanup(() => clearTimeout(timerHandle));
    }),
  );
  return debouncedSignal;
}

export function useDebounceSet(signalSetter, delay) {
  let timerHandle;
  function debouncedSignalSetter(value) {
    clearTimeout(timerHandle);
    timerHandle = setTimeout(() => signalSetter(value), delay);
  }
  onCleanup(() => clearInterval(timerHandle));
  return debouncedSignalSetter;
}

export const kebabize = (str) =>
  str.replace(
    /[A-Z]+(?![a-z])|[A-Z]/g,
    ($, ofs) => (ofs ? '-' : '') + $.toLowerCase(),
  );
